import React from 'react';
import { useEffect, useContext, useState } from "react";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { useProductContext } from "../context/productContext";
import { CartContext } from '../context/CartContext';
import FormatPrice from "../helper/FormatPrice";
import { Button } from './Button';
// import axios from '../helper/axios';
import '../pages/SingleProduct.css';

const API = "http://ec2-34-197-250-249.compute-1.amazonaws.com/api/get_products";

const JewellerySetting = () => {

    const { getSingleProduct, singleProduct, isSingleLoading } = useProductContext();

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        metal: '',
        setting: '',
    });
    const [formDataArray, setFormDataArray] = useState([]);

    const { id } = useParams();
    const { addToCart } = useContext(CartContext);

    // console.log(axios);


    // console.log('̥storedCartItems', storedCartItems);

    useEffect(() => {
        getSingleProduct(`${API}?product_id=${id}`);
    }, [id]);

    const { carat, product_image, price, cut, shape, color } = singleProduct;

    //  console.log(singleProduct);

    if (isSingleLoading) {
        return <div className="page_loading">Loading.....</div>;
    }

    // const handleAddToCart = () => {
    //     setFormDataArray((prevArray) => [...prevArray, formData]); // Add current formData to array
    //     setFormData({ metal: '', setting: '' }); // Reset formData
    // };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        const product = {
            id: singleProduct.product_id,
            cut: cut,
            carat: carat,
            shape: shape,
            color: color,
            name: `${shape} Shaped ${carat} Carat ${cut} Cut Lab Grown Diamond`,
            price: price + 0,
            metal: formData.metal,
            setting: formData.setting,
            quantity: 1
        };

        const storedCartItems = JSON.parse(localStorage.getItem('cartItems'));

        if (storedCartItems.length !== 0) {
            const isDuplicate = storedCartItems.some(element => element.id === product.id);

            if (isDuplicate) {
                alert('Update qty');
                addToCart(product);
            } else {
                addToCart(product);
                // navigate(`/cart`, { data: product });
                alert('added');
            }
        }
        else {
            addToCart(product);
            // navigate(`/cart`, { data: product });
            alert('storedCartItems.length added');
        }
    };

    return (
        <>
            <section>
                <div className='page-banner hero-container'>
                    <div className='banner-content'>
                        <h1>Product Page</h1>
                    </div>
                </div>
            </section>

            <section className="light-section single-product-section">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6">
                            <figure className='cards__item__pic-wrap'>
                                <img
                                    className='cards__item__img'
                                    alt='Diamond'
                                    src={product_image}
                                />
                            </figure>
                        </div>
                        <div className="col-sm-6">
                            <div className="product-data">
                                <div className="product-title">{shape} Shaped {carat} Carat {cut} Cut Lab Grown Diamond</div>
                                <div className="product-detail">
                                    <span> {carat} carat</span> | <span>{cut} cut</span> | <span>{shape} shape</span>
                                </div>

                                <div className="product-price">  <FormatPrice price={price + 0} /></div>

                                <div className='hero-btn1 mt-4 row'>
                                    <div className="col-sm-4">

                                        <form onSubmit={handleFormSubmit}>
                                            <label>
                                                Metal:
                                                <input required type="text" name="metal" value={formData.metal} onChange={(e) => setFormData({ ...formData, metal: e.target.value })} />
                                            </label>
                                            <br />
                                            <label>
                                                Setting:
                                                <input required type="text" name="setting" value={formData.setting} onChange={(e) => setFormData({ ...formData, setting: e.target.value })} />
                                            </label>
                                            <br />
                                            <Button
                                                className="btns"
                                                buttonStyle="btn__primary"
                                                buttonSize="btn__medium"
                                                type="submit"
                                            >
                                                Select Setting
                                            </Button>
                                        </form>
                                    </div>

                                    <div>
                                        <h2>Form Data Array:</h2>
                                        {formDataArray.map((data, index) => (
                                            <div key={index}>
                                                <p>Metal: {data.metal}</p>
                                                <p>Setting: {data.setting}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="product-content mt-5">
                        <h2 className="text-center">Description</h2>
                        <p className="text-center my-1">This 0.55 carat Round shaped lab grown diamond has E color, SI1 clarity, Fair cut and is certified by IGI</p>

                        <div className="text-center mt-3">
                            <h3>SHIPPING</h3>
                            <p className="text-center my-1"> <b>Free FedEx 2Day® Shipping</b></p>
                            <p>We offer free FedEx 2Day® shipping for all items. Each item is either In-Stock or Made-to-Order. Check the product detail page once you've configured your jewelry to determine the shipping date. Once your order is completed and ready for shipment, your jewelry will ship via FedEx 2Day® for free. Expedited shipping options are available for all items at checkout. Please note: all orders require a signature for delivery.</p>
                        </div>
                    </div>
                </div >
            </section >
        </>
    );
}

export default JewellerySetting